<template>
    <div>
        <a-config-provider :locale="antdLocale">
            <a-card>
                <a-row>
                    <a-col :span="24">
                        <p class="text">{{ l('Issue_Config') }}</p>
                    </a-col>

                    
					<a-col :span="24">
					    <a-checkbox v-model="greaterThan">
					        {{ l('progress-of-the-problem-must-be-greater') }}
					    </a-checkbox>
					</a-col>
					<a-col :span="24">
					    <a-checkbox v-model="closePermission">
					        {{ l('Discovered-that-people-can-close-the-issue') }}
					    </a-checkbox>
					</a-col>
					<a-col :span="24">
					    <a-checkbox v-model="responsibleClosePermission">
					        {{ l('Allow_responsible_to_close_issues') }}
					    </a-checkbox>
					</a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="remark">
                            {{ l('Fill_in_the_remark_before_closing_the_question') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsRequiredIssueResp">
                            {{ l('WhetherThePersonResponsibleForTheQuestionIsMandatory') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsRequiredPhotoIssueResp">
                            {{ l('Isphotomandatoryuploadedproblemisdiscovered') }}
                        </a-checkbox>
                    </a-col>

                    

                    <!-- <a-col :span="24" style="display: flex;">
                        <p style="margin: auto 0;">{{ l('Issue_progress_reminders') + '：' }}</p>
                        <a-select :filterOption="filterOption" style="width: 150px;margin-left: 10px;"
                            v-model="Progress" :placeholder="l('issueprogress.Progress')" @change="issueProgressChange"
                            allow-clear>
                            <a-select-option v-for="item in issueProgressList" :key="item.progress" :title="item.name">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </a-col> -->
                    <a-col :span="24">
                       <span>{{l('Question_required_setting') + ':'}}</span>
                    </a-col>
                    <a-col :span="24">
                        <table border="1">
                            <tr>
                                <td></td>
                                <td>{{l('When_Submitting')}}</td>
                                <td>{{l('When_Updating')}}</td>
                                <td>{{l('When_Closed')}}</td>
                            </tr>
                            <tr>
                                <td>{{l('audit.plandate')}}</td>
                                <td>
                                    <a-checkbox v-model="EnableSubmitPlanTime">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableUpdatePlanTime">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableClosePlanTime">
                                    </a-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{l('issue.improvepicture')}}</td>
                                <td>
                                    <a-checkbox v-model="EnableSubmitImprovePicture">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableUpdateImprovePicture">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableCloseImprovePicture">
                                    </a-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{l('issue.correctiveNote')}}</td>
                                <td>
                                    <a-checkbox v-model="EnableSubmitCorrectiveNote">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableUpdateCorrectiveNote">
                                    </a-checkbox>
                                </td>
                                <td>
                                    <a-checkbox v-model="EnableCloseCorrectiveNote">
                                    </a-checkbox>
                                </td>
                            </tr>
                            <tr>
                                <td>{{l('Point')}}</td>
                                <td><a-checkbox v-model="EnableSubmitAuditPoint"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableUpdateAuditPoint"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableCloseAuditPoint"></a-checkbox></td>
                            </tr>
                            <tr>
                                <td>{{l('IssueType')}}</td> 
                                <td><a-checkbox v-model="EnableSubmitCategory"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableUpdateCategory"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableCloseCategory"></a-checkbox></td>
                            </tr>
                            <tr>
                                <td>{{l('ReasonAnalyse')}}</td>
                                <td><a-checkbox v-model="EnableSubmitReasonAnalyse"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableUpdateReasonAnalyse"></a-checkbox></td>
                                <td><a-checkbox v-model="EnableCloseReasonAnalyse"></a-checkbox></td>
                            </tr>
                        </table>
                    </a-col>

                    <a-col :span="24">
                        <p class="text">{{ l('Security_hazard_configuration') }}</p>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabledAssistantConfirmationProcess">
                            {{ l('enable_specialist_confirmation_process') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24" style="display: flex;margin-bottom: 5px;">
                        <p style="margin: auto 0;">{{ l('Issue_Confirmation_Specialist') + '：' }}</p>
                        <a-select showSearch mode="multiple" style="width: 200px;text-align: left;"
                            dropdownClassName="drop-down-Style" :dropdownMatchSelectWidth="false"
                            v-model="IssueConfirmAssistant" :placeholder="l('please_enter_your_username_to_search')"
                            allow-clear optionFilterProp="label">
                            <a-select-option v-for="item in userlist" :key="item.id" :label="item.realName">
                                {{ item.realName }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="24" style="display: flex;margin-bottom: 5px;">
                        <p style="margin: auto 0;">{{ l('Plan_end_time_duration_not_filled_in') + '：' }}</p>
                        <a-input-number v-model="IssuePlanTimeNotFilledInHour" style="width: 100px;" :min="0"></a-input-number>
						<p style="margin: auto 0;margin-left: 10px;">{{ l('Only_effective_when_the_plan')}}</p>
                    </a-col>


                    <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">{{ l('Audit_settings') }}</p>
                    </a-col>

                    

                    <a-col :span="24">
                        <a-checkbox v-model="IsIssueFeedbackButton">
                            {{ l('Whether_to_enable_the_issue_feedback_button') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="Isnonconformances">
                            {{ l('Whether_nonconformances_are_enabled') }}
                        </a-checkbox>
                    </a-col>
					
					<a-col :span="24" style="display: flex;margin-top: 5px;">
					    <p style="margin: auto 0;">{{ l('At_least_submit_the_audit_task') + '：' }}</p>
					    <a-input-number v-model="minIssuesPerAudit" style="width: 100px;" :min="0"></a-input-number>
					    <p style="margin: auto 0;margin-left: 10px;">{{ l('issues')}}</p>
					</a-col>
					
					<a-col :span="24" style="display: flex;margin-top: 5px;">
					    <p style="margin: auto 0;">{{ l('Ignore_the_classification_of_problems') + '：' }}</p>
						<a-tree-select v-model="issueTypeId" style="width:400px" :tree-data="issueTypelist"
						    :replace-fields="issueType" multiple
						    :dropdown-style="{ maxHeight: '400px', overflow: 'auto',width: '300px' }"
						    :dropdownMatchSelectWidth=false :placeholder="l('Issue_tip_select')" allow-clear
						    tree-default-expand-all>
						</a-tree-select>
					</a-col>

					<a-col :span="24" style="display: flex;margin-top: 5px;">
					    <p style="margin: auto 0;">{{ l('Classification_of_Hidden_Issues') + '：' }}</p>
						<a-tree-select v-model="hiddenIssueTypeId" style="width:400px" :tree-data="issueTypelist"
						    :replace-fields="issueType" multiple
						    :dropdown-style="{ maxHeight: '400px', overflow: 'auto',width: '300px' }"
						    :dropdownMatchSelectWidth=false :placeholder="l('Issue_tip_select')" allow-clear
						    tree-default-expand-all>
						</a-tree-select>
					</a-col>

                    <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">{{ l('Audit_task_settings') }}</p>
                    </a-col>

                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabledAuditTaskTransfer">
                            {{ l('Whether_to_enable_task_transfer') }}
                        </a-checkbox>
                    </a-col>

                    <br>

                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabled.filedExt1">
                            {{ l('Whether_to_enable_extended_fields', 1) }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabled.filedExt2">
                            {{ l('Whether_to_enable_extended_fields', 2) }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabled.filedExt3">
                            {{ l('Whether_to_enable_extended_fields', 3) }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabled.templateBarCode">
                            {{ l('Whether_barcodes_are_enabled') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnabled.assitField">
                            {{ l('Whether_to_enable_secondary_fields') }}
                        </a-checkbox>
                    </a-col>

                    <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">{{ l('PictureSettings') }}</p>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnableUploadPicture">
                            {{ l('Whether_to_disable_image_upload') }}
                        </a-checkbox>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnableImagesFromAlbums">
                            {{ l('Disable_selecting_images_from_albums') }}
                        </a-checkbox>
                    </a-col>

                    <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">{{ l('VideoSettings') }}</p>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnableOpenPhoneAlbum">
                            {{ l('Enable_video_shooting') }}
                        </a-checkbox>
                    </a-col>

                    <a-col :span="24">
                        <a-checkbox v-model="IsEnableUploadVideo">
                            {{ l('Enable_video_selection_from_album') }}
                        </a-checkbox>
                    </a-col>

                    <!-- <a-col :span="24" style="display: flex;">
                        <p style="margin: auto 0;">{{ l('Video_Duration') + '：' }}</p>
                        <a-input-number v-model="VideoDuration" style="width: 100px;" :min="0" :max="60"
                            :formatter="value => `${value}` + l('Second')"
                            :parser="value => value.replace(l('Second'), '')"></a-input-number>
                    </a-col>

                    <a-col :span="24" style="display: flex;margin-top: 10px;">
                        <p style="margin: auto 0;">{{ l('Video_Quality') + '：' }}</p>
                        <a-select :filterOption="filterOption" style="width: 150px;margin-left: 10px;"
                            v-model="VideoResolution" :placeholder="l('Video_Quality_Configuration')" @change="VideoResolutionChange"
                            allow-clear>
                            <a-select-option v-for="item in VideoResolutionList" :key="item.itemDetailCode"
                                :title="item.itemDetailName">
                                {{ item.itemDetailName }}
                            </a-select-option>
                        </a-select>
                    </a-col>

                    <a-col :span="24" style="margin-top: 10px;">
                        <img src="../../../../public/img/image/resolutionRatio.png" />
                    </a-col> -->

                    <!-- <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">每日审核任务报表</p>
                    </a-col>
                    <a-col :span="24" style="display: flex;">
                        <div style="width: 100px;line-height: 32px;">启用:</div>
                        <a-checkbox v-model="dailyAuditTaskReportConfig.isEnabled">启用每日发送</a-checkbox>
                    </a-col>
                    <a-col :span="24" style="display: flex;margin-top: 12px;">
                        <div style="width: 100px;line-height: 32px;">发送时间:</div>
                        <a-input-number v-model="dailyAuditTaskReportConfig.sendHour" :min="0" :max="23" style="width: 90px;" />
                        <span style="line-height: 32px;margin: 0 8px;">时</span>
                        <a-input-number v-model="dailyAuditTaskReportConfig.sendMinute" :min="0" :max="59" style="width: 90px;" />
                        <span style="line-height: 32px;margin-left: 8px;">分</span>
                    </a-col>
                    <a-col :span="24" style="display: flex;margin-top: 12px;">
                        <div style="width: 100px;line-height: 32px;">接收人:</div>
                        <a-select v-model="dailyAuditTaskReportConfig.recipientUserIds" mode="multiple" allow-clear
                            show-search option-filter-prop="children" style="width: 500px;" placeholder="请选择接收日报的系统用户">
                            <a-select-option v-for="user in dailyAuditTaskReportUsers" :key="user.id" :value="user.id">
                                {{ user.name }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                    <a-col :span="24" style="margin: 8px 0 0 100px;">
                        <span class="tips-text">仅显示当前场景中已绑定岗位的用户。接收人按岗位及子岗位生成当天任务范围内的 Excel 报表，并通过钉钉发送。</span>
                    </a-col> -->
                    <a-col :span="24" style="margin-top: 30px;">
                        <p class="text">{{ l('Departmental_Report_Settings') }}</p>
                    </a-col>
                    <a-col :span="24">
                        <a-checkbox v-model="IsEnableStatisticsOrg">
                            {{ l('Whether_to_enable_department_affiliation') }}
                        </a-checkbox>
                    </a-col>

                    <a-col :span="24" style="display: flex;margin-top: 5px;">
                        <div style="line-height: 50px;">
                            <span>
                                {{ l('Departmental_affiliation_configuration') + '：' }}
                            </span>
                        </div>
                        <a-input v-model="StatisticsOrgConfig" class="input"
                            style="color: black;width: 300px; margin: 10px 10px 0 0; "
                            :placeholder="l('Departmental_affiliation_configuration')"></a-input>
                    </a-col>

                    <a-col :span="24" style="margin-top: 15px;">
                        <a-button :type="'primary'" @click="save()" v-if="isGranted('other_save')">
                            <a-icon type="save" />
                            <span>{{ l('Save') }}</span>
                        </a-button>
                    </a-col>
                </a-row>
            </a-card>
        </a-config-provider>
    </div>
</template>

<script>
import {
    AppComponentBase
} from "@/shared/component-base";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import { Dic, fileDownloadService } from "../../../shared/utils";
import {
    IssueServiceProxy,
	IssueTypeServiceProxy,
    EHSServiceProxy,
    SystemConfigServiceProxy,
    IssueProgressServiceProxy,
    EmployeeServiceProxy,
    AuditTaskServiceProxy,
    APPApiServiceProxy
} from '../../../shared/service-proxies';
import {
    ModalHelper
} from '@/shared/helpers';
import apiHttpClient from '@/shared/utils/api-http-client';

let _this;
export default {
    name: "issue-config",
    mixins: [AppComponentBase],
    components: {

    },
    created() {
        _this = this;
        this.IssueServiceProxy = new IssueServiceProxy(this.$apiUrl, this.$api);
		this.IssueTypeServiceProxy = new IssueTypeServiceProxy(this.$apiUrl, this.$api);
        this.EHSServiceProxy = new EHSServiceProxy(this.$apiUrl, this.$api);
        this.SystemConfigServiceProxy = new SystemConfigServiceProxy(this.$apiUrl, this.$api);
        this.IssueProgressServiceProxy = new IssueProgressServiceProxy(this.$apiUrl, this.$api);
        this._EmployeeServiceProxy = new EmployeeServiceProxy(this.$apiUrl, this.$api);
        this.AuditTaskServiceProxy = new AuditTaskServiceProxy(this.$apiUrl, this.$api);
        this.APPApiServiceProxy = new APPApiServiceProxy(this.$apiUrl, this.$api);
    },
    async mounted() {
        this.VideoResolutionList = await Dic.getInstance().getDicAsync('VideoResolution');
        this.getissueProgress();
        this.getData();
        this.getuser();
		this.getFillInCorrectiveNoteMustUpdateProgress();
		this.getIssueDiscovererIsCanCloseIssue();
		this.getRespIsCloseIssue();
        this.getRemark();
        this.getIsRequiredIssueResp();
        this.getIsRequiredPhotoIssueResp();
        this.getIsEnableUploadPicture();
        this.getIsEnableImagesFromAlbums();
        this.getIsIssueFeedbackButton();
        this.getIsnonconformances();
        this.getIsIssueNotificaationFeature();
        this.getIsExtendedFields();
        this.getIsEnableStatisticsOrg();
        this.getStatisticsOrgConfig();
        this.getIsEnableOpenPhoneAlbum();
        this.getIsEnableUploadVideo();
        // this.getVideoDuration();
        // this.getVideoResolution();
        this.getIsEnabledAssistantConfirmationProcess();
        this.getIssueConfirmAssistant();
        this.getIssuePlanTimeNotFilledInHour();
		this.getAuditMustFindIssuesConfig();
		this.getissueTreeData();
		this.getAuditExcludeIssueCategoriesConfig();
        this.getIssueRestrictedFields();
        this.GetIsEnabledAuditTaskTransfer();
		this.getIssueTypeDisplayConfig();  // 获取问题分类显示配置
        this.loadDailyAuditTaskReportUsers();
        // this.loadDailyAuditTaskReportConfig();

    },
    data() {
        return {
            zh_CN,
            isEdit: false,
            isLook: false,
            isLoading: false,
            remark: false,
            date: {},
            remarkDate: {},
            IsRequiredIssueResp: false,
            IsRequiredPhotoIssueResp: false,
            Privatekey: undefined,
            IsEnableUploadPicture: false,
            IsIssueFeedbackButton: false,
            Isnonconformances: false,
            // Progress: undefined,
            // issueProgressList: [],
            IsEnabled: {},
            IsEnableStatisticsOrg: false,
            StatisticsOrgConfig: undefined,
            IsEnableOpenPhoneAlbum: false,
            IsEnableUploadVideo: false,
            IsEnableImagesFromAlbums: false,
            dailyAuditTaskReportConfig: {
                id: null,
                scenesId: 0,
                isEnabled: false,
                sendHour: 8,
                sendMinute: 0,
                recipientUserIds: []
            },
            dailyAuditTaskReportUsers: [],
            VideoDuration: 60,
            VideoResolution: undefined,
            VideoResolutionList: [],
            userlist: [],
            userid: undefined,
            IsEnabledAssistantConfirmationProcess: false,
            IssueConfirmAssistant: undefined,
            IssuePlanTimeNotFilledInHour: 24,
            EnableSubmitPlanTime:false,
            EnableUpdatePlanTime:false,
            EnableClosePlanTime:false,
            EnableSubmitImprovePicture:false,
            EnableUpdateImprovePicture:false,
            EnableCloseImprovePicture:false,
            EnableSubmitCorrectiveNote:false,
            EnableUpdateCorrectiveNote:false,
            EnableCloseCorrectiveNote:false,

            EnableSubmitAuditPoint: false,
            EnableUpdateAuditPoint: false,
            EnableCloseAuditPoint: false,
            
            // EnableSubmitResponder: false,
            // EnableUpdateResponder: false,
            // EnableCloseResponder: false,
            
            EnableSubmitCategory: false,
            EnableUpdateCategory: false,
            EnableCloseCategory: false,
            
            EnableSubmitDescription: false,
            EnableUpdateDescription: false,
            EnableCloseDescription: false,
            
            EnableSubmitPhoto: false,
            EnableUpdatePhoto: false,
            EnableClosePhoto: false,

            IsEnabledAuditTaskTransfer:true,
			greaterThan: false,
			closePermission: false,
			responsibleClosePermission: false,
			
			EnableSubmitReasonAnalyse: false,
			EnableUpdateReasonAnalyse: false,
			EnableCloseReasonAnalyse: false,
			
			minIssuesPerAudit: 0,
			issueTypeId: [],
			issueTypelist: [],
			issueType: {
			    title: 'name',
			    key: 'id',
			    value: 'id'
			},

			hiddenIssueTypeId: []  // 隐藏的问题分类ID列表
        }
    },
    computed: {
        currentScenesId() {
            return Number(localStorage.getItem('ScenesId') || 0);
        }
    },
    methods: {
        async loadDailyAuditTaskReportUsers() {
            if (!this.currentScenesId) {
                this.dailyAuditTaskReportUsers = [];
                return;
            }
            const response = await apiHttpClient.get('/api/services/app/AuditTaskDailyReportConfig/GetRecipientUsers', {
                params: { scenesId: this.currentScenesId }
            });
            this.dailyAuditTaskReportUsers = (response && response.data) || [];
        },
        async loadDailyAuditTaskReportConfig() {
            if (!this.currentScenesId) {
                return;
            }
            const response = await apiHttpClient.get('/api/services/app/AuditTaskDailyReportConfig/GetForEdit', {
                params: { scenesId: this.currentScenesId }
            });
            const config = (response && response.data) || {};
            this.dailyAuditTaskReportConfig = {
                id: config.id || null,
                scenesId: this.currentScenesId,
                isEnabled: !!config.isEnabled,
                sendHour: config.sendHour == null ? 8 : config.sendHour,
                sendMinute: config.sendMinute == null ? 0 : config.sendMinute,
                recipientUserIds: config.recipientUserIds || []
            };
        },
        async saveDailyAuditTaskReportConfig(showSuccess = true) {
            if (!this.currentScenesId) {
                this.notify.warning('未获取到当前场景，请重新进入场景后设置。');
                return;
            }
            this.isLoading = true;
            try {
                await apiHttpClient.post('/api/services/app/AuditTaskDailyReportConfig/Save', {
                    ...this.dailyAuditTaskReportConfig,
                    scenesId: this.currentScenesId
                });
                if (showSuccess) {
                    this.notify.success(this.l('SavedSuccessfully'));
                }
                await this.loadDailyAuditTaskReportConfig();
                return true;
            } finally {
                this.isLoading = false;
            }
        },

        getuser() {
            this._EmployeeServiceProxy.getAllEmp().finally(() => {

            }).then((res) => {
                this.userlist = res;
            })
        },
		
		//获取填写改善措施必须修改进度
		getFillInCorrectiveNoteMustUpdateProgress() {
		    this.isLoading = true;
		    this.IssueServiceProxy.getFillInCorrectiveNoteMustUpdateProgress(
		
		    ).finally(() => {
		        this.isLoading = false;
		    }).then(res => {
		        this.greaterThan = res;
		    })
		},
		
		//获取问题发现人是否可以关闭问题
		getIssueDiscovererIsCanCloseIssue() {
		    this.isLoading = true;
		    this.IssueServiceProxy.getIssueDiscovererIsCanCloseIssue(
		
		    ).finally(() => {
		        this.isLoading = false;
		    }).then(res => {
		        this.closePermission = res;
		    })
		},
		
		//获取问题责任人是否可以关闭问题
		getRespIsCloseIssue() {
		    this.isLoading = true;
		    this.SystemConfigServiceProxy.getRespIsCloseIssue(
		
		    ).finally(() => {
		        this.isLoading = false;
		    }).then(res => {
		        this.responsibleClosePermission = res;
		    })
		},
		
        //获取关闭问题前为否填写备注
        getRemark() {
            this.isLoading = true;
            this.IssueServiceProxy.getIsCloseIssueFillInRemarks(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.remark = res;
            })
        },

        //获取进度值
        getissueProgress() {
            this.isLoading = true;
            this.IssueProgressServiceProxy.getPaged().finally(() => {
                this.isLoading = false;
            }).then(res => {
                console.log(res);
                this.issueProgressList = res.items;
            })
        },

        //获取问题责任人是否必填
        getIsRequiredIssueResp() {
            this.isLoading = true;
            this.IssueServiceProxy.getIsRequiredIssueResp(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsRequiredIssueResp = res;
            })
        },

        //获取问题发现时拍照是否必填
        getIsRequiredPhotoIssueResp() {
            this.isLoading = true;
            this.IssueServiceProxy.getIsRequiredPhotoIssueResp(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsRequiredPhotoIssueResp = res;
            })
        },

        //获取是图片上传是否禁用
        getIsEnableUploadPicture() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableUploadPicture(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsEnableUploadPicture = !res;
            })
        },

        //获取是图片上传是否禁用
        getIsEnableImagesFromAlbums() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableUploadPictureForPhone(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsEnableImagesFromAlbums = res;
            })
        },

        //获取是否启用问题反馈按钮
        getIsIssueFeedbackButton() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableAuditPointFeedback(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsIssueFeedbackButton = res;
            })
        },

        //获取是否启用不符合项
        getIsnonconformances() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableAuditTaskDetailDeviationType(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.Isnonconformances = res;
            })
        },

        //是否启用带关闭问题通知
        getIsIssueNotificaationFeature() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getToBeClosedIssueNoticeProgress(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                if (res == -1) {
                    this.Progress = undefined;
                }
                else {
                    this.Progress = res;
                }
            })
        },

        //审核任务
        getIsExtendedFields() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getFiledExtSettings(

            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
                this.IsEnabled = res;
            })
        },

        //获取是否启用部门归属配置
        getIsEnableStatisticsOrg() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableStatisticsOrg(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IsEnableStatisticsOrg = res;
                console.log(res);
            })
        },

        //获取部门归属配置
        getStatisticsOrgConfig() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getStatisticsOrgConfig(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.StatisticsOrgConfig = res;
                console.log(res);
            })
        },

        //是否启用打开手机相册
        getIsEnableOpenPhoneAlbum() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableOpenPhoneAlbum(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IsEnableOpenPhoneAlbum = res;
            })
        },

        //是否启用上传视频
        getIsEnableUploadVideo() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getIsEnableUploadVideo(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IsEnableUploadVideo = res;
            })
        },

        //视频时长
        getVideoDuration() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getVideoDuration(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.VideoDuration = res;
            })
        },

        //视频分辨率
        getVideoResolution() {
            this.isLoading = true;
            this.SystemConfigServiceProxy.getVideoResolution(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.VideoResolution = res;
            })
        },


        //是否启用上传视频
        getIsEnabledAssistantConfirmationProcess() {
            this.isLoading = true;
            this.IssueServiceProxy.getIsEnabledAssistantConfirmationProcess(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IsEnabledAssistantConfirmationProcess = res;
            })
        },

        //视频时长
        getIssueConfirmAssistant() {
            this.isLoading = true;
            this.IssueServiceProxy.getIssueConfirmAssistant(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                if (res.length != 0) {
                    this.IssueConfirmAssistant = res.split(","); // 使用逗号加空格作为分隔符来切分字符串
                    for (let index = 0; index < this.IssueConfirmAssistant.length; index++) {
                        this.IssueConfirmAssistant[index] = parseInt(this.IssueConfirmAssistant[index]);
                    }
                }

            })
        },

        //视频分辨率
        getIssuePlanTimeNotFilledInHour() {
            this.isLoading = true;
            this.IssueServiceProxy.getIssuePlanTimeNotFilledInHour(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IssuePlanTimeNotFilledInHour = res;
            })
        },


        VideoResolutionChange(value) {
            this.VideoResolution = value;
        },

		//获取审核时必须发现几个问题
		getAuditMustFindIssuesConfig() {
		    this.isLoading = true;
		    this.IssueServiceProxy.getAuditMustFindIssuesConfig(
		
		    ).finally(() => {
		        this.isLoading = false;
		
		    }).then(res => {
				this.minIssuesPerAudit = res.minIssuesPerAudit;
		    })
		},
		
		//获取问题分类
		getissueTreeData() {
		    this.isLoading = true;
		    this.IssueTypeServiceProxy.getPaged(
		        undefined,
		    )
		        .finally(() => {
		            this.isLoading = false;
		        })
		        .then((res) => {
		            this.issueTypelist = JSON.parse(JSON.stringify(res));
		        })
		},
		
		//获取审核时排除问题分类配置
		getAuditExcludeIssueCategoriesConfig() {
		    this.isLoading = true;
		    this.IssueServiceProxy.getAuditExcludeIssueCategoriesConfig(

		    ).finally(() => {
		        this.isLoading = false;

		    }).then(res => {
				this.issueTypeId = res.excludedCategoryIds.split(',');
		    })
		},

		//获取问题分类显示配置(隐藏的问题分类)
		getIssueTypeDisplayConfig() {
		    this.isLoading = true;
		    this.APPApiServiceProxy.getIssueTypeDisplayConfig()
		        .finally(() => {
		            this.isLoading = false;
		        })
		        .then(res => {
		            if (res.hiddenIssueTypeIds && res.hiddenIssueTypeIds.length > 0) {
		                this.hiddenIssueTypeId = res.hiddenIssueTypeIds.split(',');
		            } else {
		                this.hiddenIssueTypeId = [];
		            }
		        })
		        .catch(err => {
		            console.error('获取问题分类显示配置失败', err);
		        });
		},

		// auditMustFindIssuesConfig() {
		//     this.isLoading = true;
		//     this.IssueServiceProxy.auditMustFindIssuesConfig(
		
		//     ).finally(() => {
		//         this.isLoading = false;
		
		//     }).then(res => {
		//         console.log(res)
		//     })
		// },

        //
        getIssueRestrictedFields() {
            this.isLoading = true;
            this.IssueServiceProxy.getIssueRestrictedFields(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                console.log('接口返回完整数据：', res); // 新增调试
                this.EnableSubmitPlanTime = res.enableSubmitPlanTime;
                this.EnableUpdatePlanTime = res.enableUpdatePlanTime;
                this.EnableClosePlanTime = res.enableClosePlanTime;
                this.EnableSubmitImprovePicture = res.enableSubmitImprovePicture;
                this.EnableUpdateImprovePicture = res.enableUpdateImprovePicture;
                this.EnableCloseImprovePicture = res.enableCloseImprovePicture;
                this.EnableSubmitCorrectiveNote = res.enableSubmitCorrectiveNote;
                this.EnableUpdateCorrectiveNote = res.enableUpdateCorrectiveNote;
                this.EnableCloseCorrectiveNote = res.enableCloseCorrectiveNote;
                this.EnableSubmitAuditPoint = res.enableSubmitAuditPoint;
                this.EnableUpdateAuditPoint = res.enableUpdateAuditPoint;
                this.EnableCloseAuditPoint = res.enableCloseAuditPoint;
                
                // this.EnableSubmitResponder = res.enableSubmitResponder;
                // this.EnableUpdateResponder = res.enableUpdateResponder;
                // this.EnableCloseResponder = res.enableCloseResponder;
                
                this.EnableSubmitCategory = res.enableSubmitCategory;
                this.EnableUpdateCategory = res.enableUpdateCategory;
                this.EnableCloseCategory = res.enableCloseCategory;
                
                this.EnableSubmitDescription = res.enableSubmitDescription;
                this.EnableUpdateDescription = res.enableUpdateDescription;
                this.EnableCloseDescription = res.enableCloseDescription;
				
				this.EnableSubmitReasonAnalyse = res.enableSubmitRootCauseAnalysis;
				this.EnableUpdateReasonAnalyse = res.enableUpdateRootCauseAnalysis;
				this.EnableCloseReasonAnalyse = res.enableCloseRootCauseAnalysis;
                
                // this.EnableSubmitPhoto = res.enableSubmitPhoto;
                // this.EnableUpdatePhoto = res.enableUpdatePhoto;
                // this.EnableClosePhoto = res.enableClosePhoto;
            })
        },


        //是否启用上传视频
        GetIsEnabledAuditTaskTransfer() {
            this.isLoading = true;
            this.AuditTaskServiceProxy.getIsEnabledAuditTaskTransfer(

            ).finally(() => {
                this.isLoading = false;

            }).then(res => {
                this.IsEnabledAuditTaskTransfer = res;
            })
        },

        async save() {
            // const reportSaved = await this.saveDailyAuditTaskReportConfig(false);
            //填写改善措施必须修改进度
            this.isLoading = true;
            this.IssueServiceProxy.fillInCorrectiveNoteMustUpdateProgress(
                { Enable: this.greaterThan }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })
			
			//允许发现人关闭问题
			this.isLoading = true;
			this.IssueServiceProxy.issueDiscovererIsCanCloseIssue(
			    { Enable: this.closePermission }
			).finally(() => {
			    this.isLoading = false;
			}).then(res => {
			})
			
			//允许责任人关闭问题
			this.isLoading = true;
			this.SystemConfigServiceProxy.respIsCloseIssue(
			    { Enable: this.responsibleClosePermission }
			).finally(() => {
			    this.isLoading = false;
			}).then(res => {
			})

            //问题关闭前填写备注
            this.remarkDate.enable = this.remark;
            this.isLoading = true;
            this.IssueServiceProxy.isCloseIssueFillInRemarks(
                this.remarkDate
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //问题责任人是否必填
            this.isLoading = true;
            this.IssueServiceProxy.isRequiredIssueResp(
                { Enable: this.IsRequiredIssueResp }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //问题发现时拍照是否必填
            this.isLoading = true;
            this.IssueServiceProxy.isRequiredPhotoIssueResp(
                { Enable: this.IsRequiredPhotoIssueResp }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否禁用图片上传
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableUploadPicture(
                { Enable: !this.IsEnableUploadPicture }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否禁用从相册选择图片
            this.SystemConfigServiceProxy.isEnableUploadPictureForPhone(
                { Enable: this.IsEnableImagesFromAlbums }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否启用待关闭问题通知功能
            this.isLoading = true;
            this.SystemConfigServiceProxy.toBeClosedIssueNoticeProgress(
                { Progress: this.Progress }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否启用问题反馈按钮
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableAuditPointFeedback(
                { Enable: this.IsIssueFeedbackButton }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            // 是否启用不符合项
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableAuditTaskDetailDeviationType(
                { Enable: this.Isnonconformances }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            // 审核任务
            this.isLoading = true;
            this.SystemConfigServiceProxy.updateFiledExtSettings(
                this.IsEnabled
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否禁用图片上传
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableStatisticsOrg(
                { Enable: this.IsEnableStatisticsOrg }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //部门归属配置
            this.isLoading = true;
            this.SystemConfigServiceProxy.statisticsOrgConfig(
                { StatisticsOrgConfig: this.StatisticsOrgConfig }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否启用打开手机相册
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableOpenPhoneAlbum(
                { Enable: this.IsEnableOpenPhoneAlbum }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //是否启用上传视频
            this.isLoading = true;
            this.SystemConfigServiceProxy.isEnableUploadVideo(
                { Enable: this.IsEnableUploadVideo }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            // //部门归属配置
            // this.isLoading = true;
            // this.SystemConfigServiceProxy.videoDuration(
            //     { VideoDuration: this.VideoDuration }
            // ).finally(() => {
            //     this.isLoading = false;
            // }).then(res => {
            // })

            // //部门归属配置
            // this.isLoading = true;
            // this.SystemConfigServiceProxy.videoResolution(
            //     { VideoResolution: this.VideoResolution }
            // ).finally(() => {
            //     this.isLoading = false;
            // }).then(res => {
            // })


            //是否启用专员确认流程
            this.isLoading = true;
            this.IssueServiceProxy.isEnabledAssistantConfirmationProcess(
                { Enable: this.IsEnabledAssistantConfirmationProcess }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            var  IssueConfirmAssistantstr = "";
            if (this.IssueConfirmAssistant) {
                IssueConfirmAssistantstr = this.IssueConfirmAssistant.join(","); // 使用逗号加空格连接数组元素
            }else{
                IssueConfirmAssistantstr = "";
            }
            
            //问题确认专员
            this.isLoading = true;
            this.IssueServiceProxy.issueConfirmAssistant(
                { IssueConfirmAssistant: IssueConfirmAssistantstr }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })

            //计划完成时间未填写
            this.isLoading = true;
            this.IssueServiceProxy.issuePlanTimeNotFilledInHour(
                { IssuePlanTimeNotFilledInHour: this.IssuePlanTimeNotFilledInHour }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })
			
			//审核时必须发现若干个问题项配置
			this.isLoading = true;
			this.IssueServiceProxy.auditMustFindIssuesConfig(
			    { MinIssuesPerAudit: this.minIssuesPerAudit }
			).finally(() => {
			    this.isLoading = false;
			}).then(res => {
			})
			
			//审核时排除问题分类配置
			this.isLoading = true;
			let IdList = this.issueTypeId.join(",");
			this.IssueServiceProxy.auditExcludeIssueCategoriesConfig(
			    { ExcludedCategoryIds: IdList }
			).finally(() => {
			    this.isLoading = false;
			}).then(res => {
			})

			//问题分类显示配置(隐藏的问题分类)
			this.isLoading = true;
			let hiddenIdList = this.hiddenIssueTypeId.join(",");
			this.APPApiServiceProxy.issueTypeDisplayConfig({
			    hiddenIssueTypeIds: hiddenIdList
			}).finally(() => {
			    this.isLoading = false;
			}).then(res => {
			    console.log('问题分类显示配置保存成功');
			}).catch(err => {
			    console.error('保存问题分类显示配置失败', err);
			})

            //是否启用专员确认流程
            this.isLoading = true;
            this.IssueServiceProxy.issueRestrictedFields(
                { 
                    EnableSubmitPlanTime: this.EnableSubmitPlanTime,
                    EnableUpdatePlanTime: this.EnableUpdatePlanTime,
                    EnableClosePlanTime: this.EnableClosePlanTime,
                    EnableSubmitImprovePicture: this.EnableSubmitImprovePicture,
                    EnableUpdateImprovePicture: this.EnableUpdateImprovePicture,
                    EnableCloseImprovePicture: this.EnableCloseImprovePicture,
                    EnableSubmitCorrectiveNote: this.EnableSubmitCorrectiveNote,
                    EnableUpdateCorrectiveNote: this.EnableUpdateCorrectiveNote,
                    EnableCloseCorrectiveNote: this.EnableCloseCorrectiveNote,
                    EnableSubmitAuditPoint: this.EnableSubmitAuditPoint,
                    EnableUpdateAuditPoint: this.EnableUpdateAuditPoint,
                    EnableCloseAuditPoint: this.EnableCloseAuditPoint,
                    
                    // EnableSubmitResponder: this.EnableSubmitResponder,
                    // EnableUpdateResponder: this.EnableUpdateResponder,
                    // EnableCloseResponder: this.EnableCloseResponder,
                    
                    EnableSubmitCategory: this.EnableSubmitCategory,
                    EnableUpdateCategory: this.EnableUpdateCategory,
                    EnableCloseCategory: this.EnableCloseCategory,
                    
                    EnableSubmitDescription: this.EnableSubmitDescription,
                    EnableUpdateDescription: this.EnableUpdateDescription,
                    EnableCloseDescription :this.EnableCloseDescription,
					
					EnableSubmitRootCauseAnalysis: this.EnableSubmitReasonAnalyse,
					EnableUpdateRootCauseAnalysis: this.EnableUpdateReasonAnalyse,
					EnableCloseRootCauseAnalysis: this.EnableCloseReasonAnalyse
                    
                    // EnableSubmitPhoto: this.EnableSubmitPhoto,
                    // EnableUpdatePhoto: this.EnableUpdatePhoto,
                    // EnableClosePhoto: this.EnableClosePhoto

                 }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })


            //是否启用任务转办
            this.isLoading = true;
            this.AuditTaskServiceProxy.isEnabledAuditTaskTransfer(
                { Enable: this.IsEnabledAuditTaskTransfer }
            ).finally(() => {
                this.isLoading = false;
            }).then(res => {
            })


            this.$notification.success({
                description: undefined,
                message: this.l('SavedSuccessfully'),
            });
        },

        issueProgressChange(value) {
            this.Progress = value;
        },

        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
    }
}
</script>

<style>
.pagination {
    margin: 10px auto;
    text-align: right;
}

.text {
    font-size: 18px;
    font-weight: bold;
}

td{
    width: 80px;
    text-align: center;
    line-height: 30px;
}

</style>
